module.exports = __webpack_public_path__ + "img/4T_510k_otc.e1632ce4.jpg";